<template>
  <div class="app-container">
    <div>
      <div style="padding: 10px">
        <el-button type="primary" style="margin-left: 4px" @click="newAdd" :disabled="!canWrite">新增</el-button>
        <el-button type="primary" style="margin-left: 4px" @click="openPage" :disabled="Status === 2||!canWrite">单据选择</el-button>
        <el-button type="primary" style="margin-left: 4px" @click="save" :disabled="Status === 2||!canWrite">保存</el-button>
        <el-button type="primary" style="margin-left: 4px" :disabled="!isSave || Status === 2||!canWrite" @click="handleDelete">删除</el-button>
        <el-button type="primary" style="margin-left: 4px" @click="reView" v-if="Status !== 2" :disabled="!isSave||!canReview">审核</el-button>
        <el-button type="primary" style="margin-left: 4px" @click="cancelReView" v-if="Status === 2" :disabled="!isSave||!canReview">弃审</el-button>
        <el-dropdown style="margin-left: 4px">
          <el-button type="primary" :disabled="!isSave">
            联查<i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown" style="margin-left: 4px">
            <el-dropdown-item class="dropdown-item" @click.native="goJump(1)">加工单</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <el-button type="primary" style="margin-left: 4px" :disabled="!isSave">打印</el-button>
        <el-button type="primary" @click="openSetField">明细字段</el-button>
      </div>
      <el-form :model="data" ref="form" :inline="true" :line-form="true" label-width="80px" status-icon>
        <el-row style="margin-top: 18px">
          <el-form-item label="单据日期:" required label-width="100px">
            <span class="not-edit" v-if="Status === 2">{{ data.DocDate }}</span>
            <el-date-picker v-else v-model="data.DocDate" type="date" value-format="yyyy-MM-dd" format="yyyy-MM-dd" placeholder="选择日期" style="width: 180px"
              @change="(v) => getPreviewNo(v)">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="单据编码:" required label-width="100px">
            <span style="display: inline-block; width: 180px" v-if="Mode == 0" class="detail-span">{{ data.DocNo }}</span>
            <el-input style="width: 180px" v-else v-model="data.DocNo" placeholder="请输入单据编码"></el-input>
          </el-form-item>
          <el-form-item label="业务类型:" label-width="100px">
            <span class="not-edit" style="width: 180px" v-if="Status === 2">{{
              data.BusinessType
            }}</span>
            <!-- <business-select
              v-else
              v-model="data.BusinessTypeId"
              style="width: 190px"
            /> -->
            <el-select v-else v-model="data.BusinessTypeId" style="width: 180px">
              <el-option @click.native="BusinessChange(item)" v-for="item in businessTypeList" :key="item.BusinessTypeId" :label="item.BusinessType"
                :value="item.BusinessTypeId"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="委外供应商:" required label-width="100px" prop="TradeUnitId">
            <span class="not-edit" v-if="Status === 2">{{
              data.TradeUnitName
            }}</span>
            <el-select v-else style="width: 180px" filterable v-model="data.TradeUnitId">
              <el-option v-for="item in tradeUnitList" :key="item.key" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="委外仓库:" required label-width="100px">
            <span class="not-edit" v-if="Status === 2">{{
              data.SiteWarehouseName
            }}</span>
            <el-select v-else style="width: 180px" v-model="data.SiteWarehouseId" @change="changeDataSiteWarehouse">
              <el-option v-for="item in warehouseList2" :key="item.key" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="普通仓库:" label-width="100px">
            <span class="not-edit" v-if="Status === 2">{{
              data.GeneralWarehouseName
            }}</span>
            <el-select v-else style="width: 180px" v-model="data.GeneralWarehouseId" @change="changeDataGeneralWarehouse">
              <el-option v-for="item in warehouseList1" :key="item.key" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="车间:" label-width="100px">
            <span class="not-edit" v-if="Status === 2">{{
              data.WorkShopName
            }}</span>
            <v-select v-else style="width: 180px" ref="typeSelect" v-model="data.WorkShopId" />
          </el-form-item>
          <el-form-item label="经手人:" required label-width="100px">
            <span class="not-edit" v-if="Status === 2">{{ data.EmpName }}</span>
            <select-input v-else placeholder="请选择经办人" :label="data.EmpName" v-model="data.EmpId" @click="openEmp" style="width: 180px" />
          </el-form-item>
          <el-form-item label="制单人:" label-width="100px">
            <span class="span" style="width: 180px !important">{{
              data.MakeEmpName
            }}</span>
          </el-form-item>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="备注:" label-width="100px">
              <el-input type="textarea" v-model="data.Remark" :autosize="{ minRows: 2, maxRows: 4 }" maxlength="60" placeholder="请填写备注信息" :disabled="Status === 2"
                style="width: 600px" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-tabs v-model="activeName" @tab-click="handleClick" class="custom-tabs">
        <el-tab-pane label="明细" name="1">
          <el-table border class="table_bottom table-line tb-c-head" :data="tableData" stripe style="margin-top: 18px" :row-class-name="tableRowClassName" @row-click="add"
            v-keymove="newLine" v-if="showDetail">
            <insert-row @on-insert="onInsert" />
            <el-table-column min-width="160" align="left" label="备注" v-if="showField('备注')">
              <template slot-scope="{ row }">
                <span v-if="Status === 2">{{ row.Remark }}</span>
                <el-input v-else v-model="row.Remark" @change="editT(row)" placeholder="请输入备注" />
              </template>
            </el-table-column>
            <el-table-column label="加工单号" prop="SourceNo" align="left" min-width="100" v-if="showField('加工单号')">
            </el-table-column>
            <el-table-column label="委外仓库" prop="SiteWarehouseId" align="left" min-width="120" v-if="showField('委外仓库')">
              <template slot-scope="{ row }">
                <span class="not-edit" v-if="Status === 2">{{ row.SiteWarehouseName }}</span>
                <el-select v-else v-model="row.SiteWarehouseId" @change="changeSiteWarehouse($event, row)">
                  <el-option v-for="item in warehouseList2" :key="item.key" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column label="普通仓库" prop="GeneralWarehouseId" align="left" min-width="100" v-if="showField('普通仓库')">
              <template slot-scope="{ row }">
                <span class="not-edit" v-if="Status === 2">{{
                  row.GeneralWarehouseName
                }}</span>
                <el-select v-else v-model="row.GeneralWarehouseId" @change="changeGeneralWarehouse($event, row)">
                  <el-option v-for="item in warehouseList1" :key="item.key" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column label="存货名称" prop="ProductName" align="left" min-width="100" v-if="showField('存货名称')">
              <template slot-scope="{ row }">
                <span class="not-edit" v-if="Status === 2">{{
                  row.ProductName
                }}</span>
                <account-select v-else v-model="row.ProductName" :source="DAccount" @select="onSelect($event, row)" :pageSize="pageParams.pageSize" :pageIndex="pageParams.pageIndex"
                  :listTotal="listTotal" @inputText="inputText($event, row)" @click.native="resetFun" @currentPage="currentPage($event, row)" :pageType="true" />
              </template>
            </el-table-column>
            <el-table-column label="存货编码" prop="ProductNo" align="left" min-width="160" v-if="showField('存货编码')">
              <template slot-scope="{ row }">
                <span>{{ row.ProductNo }}</span>
              </template>
            </el-table-column>
            <el-table-column align="left" label="批号" min-width="300px" v-if="showField('批号')">
              <template slot-scope="{ row, $index }">
                <span v-if="!row.ProductName" style="color:#999;">请先选择存货</span>
                <span class="not-edit" v-else-if="Status === 2">{{row.BatchNumber}}</span>
                <span v-else-if="!row.IsBatchNumber" class="text-gray">该存货未启用批号</span>
                <account-select v-else 
                  v-model="row.BatchNumber" 
                  :Head='Head'
                  :source="batchList"
                  :listTotal="batchListTotal" :pageType="true" 
                  :pageSize="batchPageParams.pageSize" :pageIndex="batchPageParams.pageIndex"
                  @select="onSelBatch($event, row, $index)" 
                  @inputText="inputTextBatch($event, row)" 
                  @click.native="onOpenBatch($event, row, $index)" 
                  @currentPage="currentPageBatch($event, row)" 
                  keyword="BatchNumber"/>
              </template>
            </el-table-column>
            <el-table-column label="规格型号" prop="ProductSpec" align="left" min-width="100" v-if="showField('规格型号')">
              <template slot-scope="{ row }">
                <span>{{ row.ProductSpec }}</span>
              </template>
            </el-table-column>
            <el-table-column label="属性" prop="PropertyId" align="left" min-width="100" key="table1_6" v-if="showField('属性')">
              <template slot-scope="{ row }">
                <el-select v-if="row.UseProcess && Status !== 2 && (row.SourceDocId === 0 || row.SourceDocId  == null) || (Status !== 2 && row.PropertyId)" v-model="row.PropertyId"
                  @change="changeProperty($event, row)">
                  <el-option v-for="item in propertyList" :key="item.PropertyId" :label="item.PropertyName" :value="item.PropertyId"></el-option>
                </el-select>
                <span class="not-edit" v-else>{{
                  row.UseProcess ? row.PropertyName : ""
                }}</span>
              </template>
            </el-table-column>
            <el-table-column label="颜色" prop="ColorId" align="left" min-width="100" key="table1_7" v-if="showField('颜色')">
              <template slot-scope="{ row }">
                <el-select v-if="row.UseColor && Status !== 2 && (row.SourceDocId === 0 || row.SourceDocId  == null) || (Status !== 2 && row.ColorId)" v-model="row.ColorId"
                  @change="changeColor($event, row)">
                  <el-option v-for="item in row.Colors" :key="item.ColorId" :label="item.ColorName" :value="item.ColorId" :disabled="item.Status==0"></el-option>
                </el-select>
                <span class="not-edit" v-else>{{  row.UseColor ? row.ColorName : "" }}</span>
              </template>
            </el-table-column>
            <el-table-column label="计量单位" prop="UnitId" align="left" min-width="100" key="table1_8" v-if="showField('计量单位')">
              <template slot-scope="{ row,$index }">
                <span class="not-edit" v-if="Status === 2 || row.Units.length === 0">{{ row.UnitName }}</span>
                <el-select v-else v-model="row.UnitId" :disabled="Status === 2">
                  <el-option v-for="item in row.Units" :key="item.UnitId" :label="item.UnitName" :value="item.UnitId" @click.native="compareSaUnit(item, row, $index)"></el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column align="left" label="计量单位2" min-width="120px" v-if="showField('计量单位2')">
              <template slot-scope="{ row, $index }">
                <!-- <span>{{ row }}{{ $index }}</span> -->
                <el-select v-if="row.Units && row.Units.length > 0" v-model="row.UnitId2" :disabled="Status === 2">
                  <el-option v-for="item in row.Units" :key="item.UnitId" :value="item.UnitId" :label="item.UnitName" @click.native="compareUnitId(item, row, $index)"></el-option>
                </el-select>
                <span v-else-if="row.UnitType==0"></span>
                <span v-else>{{ row.UnitName2 }}</span>
              </template>
            </el-table-column>
            <el-table-column label="数量" prop="Quantity" align="right" min-width="100" key="table1_9" v-if="showField('数量')">
              <template slot-scope="{ row,$index }">
                <span class="not-edit" v-if="Status === 2">{{ $commonJs.toThousands(row.Quantity) }}</span>
                <el-input type="text" v-else @change="changeQuantity($event, row, $index)" v-model="row.Quantity"></el-input>
              </template>
            </el-table-column>
            <el-table-column align="right" label="数量2" min-width="120px" v-if="showField('数量2')">
              <template slot-scope="{ row,$index }">
                <span v-if="Status === 2">{{ $commonJs.toThousands(row.Quantity2) }}</span>
                <span v-else-if="row.UnitType==0"></span>
                <el-input v-else v-quantity:[option]="option" type="text" v-model="row.Quantity2" @change="changeQuantity2($event, row, $index)"></el-input>
              </template>
            </el-table-column>
            <el-table-column align="right" label="换算率" v-if="showField('换算率')">
              <template slot-scope="{ row, $index }">
                <span v-if="(Status === 2 || row.ChangeType === 0) && row.UnitType==1 ">{{ row.Rate }}</span>
                <span v-else-if="row.UnitType==0"></span>
                <span v-else-if="row.HasGrammage == true">{{ row.Rate }}</span>
                <el-input v-else type="text" v-model="row.Rate" @input="RateChange($event, row, $index)"></el-input>
              </template>
            </el-table-column>
            <el-table-column label="单价" prop="Price" align="right" min-width="100" key="table1_10" v-if="canPrice&&showField('单价')">
              <template slot-scope="{ row }">
                <span class="not-edit" v-if="Status === 2">{{ row.Price }}</span>
                <el-input type="text" v-else @input="changePrice($event, row)" v-model="row.Price"></el-input>
              </template>
            </el-table-column>
            <el-table-column label="单价2" prop="Price2" align="right" min-width="100" v-if="canPrice&&showField('单价2')">
              <template slot-scope="{ row }">
                <span class="not-edit" v-if="Status === 2">{{ row.Price2 }}</span>
                <el-input v-else v-show="row.UnitId2 || (row.Units2 && row.Units2.length !== 0)" type="text" v-model="row.Price2" @change="changePrice2($event, row)"></el-input>
              </template>
            </el-table-column>
            <el-table-column label="金额" prop="Amount" align="right" min-width="100" key="table1_11" v-if="canPrice&&showField('金额')">
              <template slot-scope="{ row }">
                <span class="not-edit" v-if="Status === 2">{{ $commonJs.toThousands(row.Amount) }}</span>
                <el-input type="text" v-else @change="changeAmount($event, row)" v-model="row.Amount"></el-input>
              </template>
            </el-table-column>
            <el-table-column label="克重" prop="Grammage" align="right" min-width="100" v-if="showField('克重')">
              <template slot-scope="{ row, $index }">
                <span class="not-edit" v-if="Status === 2">{{ $commonJs.toThousands(row.Grammage) }}</span>
                <el-input type="text" v-else-if="row.HasGrammage == true" @change="changeGrammage($event, row, $index)" v-model="row.Grammage"></el-input>
              </template>
            </el-table-column>
            <el-table-column label="操作" fixed="right" align="center" width="80">
              <template slot-scope="{ row, $index }">
                <el-button type="text" @click="del(row, $index)" :disabled="Status === 2">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane label="汇总" name="2">
          <el-table border class="table_bottom table-line tb-c-head" :data="tableDataSummary" stripe style="margin-top: 18px"
            v-keymove="newLine" v-if="showDetail" show-summary :summary-method="getSummaries">
            <el-table-column label="存货名称" prop="ProductName" align="left" min-width="100" v-if="showField('存货名称')">
              <template slot-scope="{ row }">
                <span>{{ row.ProductName }}</span>
              </template>
            </el-table-column>
            <el-table-column label="存货编码" prop="ProductNo" align="left" min-width="160" v-if="showField('存货编码')">
              <template slot-scope="{ row }">
                <span>{{ row.ProductNo }}</span>
              </template>
            </el-table-column>
            <el-table-column label="计量单位" prop="UnitName" align="left" min-width="100" key="table1_8" v-if="showField('计量单位')">
              <template slot-scope="{ row }">
                <span>{{ row.UnitName }}</span>
              </template>
            </el-table-column>
            <el-table-column label="数量" prop="Quantity" align="right" min-width="100" key="table1_9" v-if="showField('数量')">
              <template slot-scope="{ row }">
                <span>{{ $commonJs.toThousands(row.Quantity) }}</span>
              </template>
            </el-table-column>
            <el-table-column align="left" prop="UnitName2" label="计量单位2" min-width="120px" v-if="showField('计量单位2')">
              <template slot-scope="{ row }">
                <span v-if="row.UnitType==0"></span>
                <span v-else>{{ row.UnitName2 }}</span>
              </template>
            </el-table-column>
            <el-table-column align="right" label="数量2" prop="Quantity2" min-width="120px" v-if="showField('数量2')">
              <template slot-scope="{ row }">
                <span v-if="row.UnitType==0"></span>
                <span v-else>{{ $commonJs.toThousands(row.Quantity2) }}</span>
              </template>
            </el-table-column>
            <el-table-column label="单价" prop="Price" align="right" min-width="100" key="table1_10" v-if="canPrice&&showField('单价')">
              <template slot-scope="{ row }">
                <span>{{ row.Price }}</span>
              </template>
            </el-table-column>
            <el-table-column label="单价2" prop="Price2" align="right" min-width="100" v-if="canPrice&&showField('单价2')">
              <template slot-scope="{ row }">
                <span v-if="row.UnitType==0"></span>
                <span v-else>{{ row.Price2 }}</span>
              </template>
            </el-table-column>
            <el-table-column label="金额" prop="Amount" align="right" min-width="100" key="table1_11" v-if="canPrice&&showField('金额')">
              <template slot-scope="{ row }">
                <span>{{ $commonJs.toThousands(row.Amount) }}</span>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
      </el-tabs>
      <div class="mtx10">
        <div class="flex space-between">
          <div class="flex flex1">
            <div class="mrx18 center el-form-item__label">审核人</div>
            <div class="center el-form-item__label">{{ data.ReviewEmpName }}</div>
          </div>
          <div class="flex flex1">
            <div class="mrx18 center el-form-item__label">审核时间</div>
            <div class="center el-form-item__label">{{ data.ReviewTime }}</div>
          </div>
        </div>
      </div>
    </div>
    <emp-dialog ref="empDialog" in-dialog selectable @select="setEmp" />
    <edit-dialog ref="editDialog" @saved="saved" :OrderType="OrderType"></edit-dialog>
    <field-dialog ref="fieldDialog" @close-saved="setTbField" />
  </div>
</template>
<script>
import editDialog from "./editDialog";
import accountSelect from "@/components/business/stock/select";
import vSelect from "@/components/business/stock/productionpicking/vSelect";
import empDialog from "@/components/personnel/result/record/listDialog";
import optionMixins from "@/mixins/option";
import fieldDialog from "@/components/common/fieldDialog"

export default {
  mixins: [optionMixins],
  name: "editoutsourcingpicking",
  components: {
    editDialog,
    accountSelect,
    vSelect,
    empDialog,
    fieldDialog
  },
  data() {
    return {
      pdApi: require("@/api/ba/product").default,
      warehouseApi: require("@/api/ba/warehouse").default,
      businessTypeApi: require("@/api/ba/businessType").default,
      code_api: require("@/api/sy/serialCode").default,
      api: require("@/api/pr/prGetDoc").default,
      sourceTypeApi: require("@/api/ba/sourceType").default,
      propertyApi: require("@/api/ba/property").default,
      tradeUnitApi: require("@/api/ba/tradeUnit").default,
      docSetting_api: require('@/api/sy/docSetting').default,
      propertyList: [],
      activeName: "1",
      Mode: 0,
      businessTypeList: [],
      warehouseList1: [], // 库存仓
      warehouseList2: [], // 现场仓/车间仓
      tradeUnitList: [],
      initDAccount: [],
      initTotal: 0,
      DAccount: [],
      listTotal: 0,
      pageParams: {
        pageSize: 7, //分页大小
        pageIndex: 1,
      },
      data: {
        DocId: 0,
        GetType: 1,
        DocDate: this.$commonJs.getToday(),
        DocNo: "",
        WorkShopId: 0,
        WorkShopName: "",
        MinusEntry: '',
        BusinessTypeId: "",
        GeneralWarehouseId: null,
        GeneralWarehouseName: "",
        SiteWarehouseId: null,
        SiteWarehouseName: "",
        TradeUnitId: null,
        TradeUnitName: "",
        EmpName: "",
        EmpId: 0,
        MakeEmpName: "",
        MakeEmpId: 0,
        ReviewEmpName: "",
        ReviewEmpId: 0,
        ReviewTime: "",
        BusinessTypeNo: "",
        BusinessType: "",
        Remark: "",
      },
      date: [],
      Status: 0,
      isSave: false,
      tableData: [
        {
          T: 0,
          DocId: 0,
          DocProductId: 0,
          WorkDocNo: "",
          SiteWarehouseId: null,
          GeneralWarehouseId: null,
          SiteWarehouseName: "",
          GeneralWarehouseName: "",
          ProductId: null,
          ProductNo: "",
          ProductName: "",
          ProductSpec: "",
          PropertyId: null,
          PropertyName: "",
          ColorId: null,
          ColorName: "",
          Colors: [],
          Units: [],
          UnitId: null,
          UnitName: "",
          Quantity: null,
          Price: null,
          Amount: null,
          UnitId2: null,
          UnitName2: "",
          Price2: null,
          Quantity2: null,
          Rate: null,
          SourceDocId: 0,
          SourceNo: "",
          SourceDtsId: 0,
          SourceType: 0,
          Remark: "",
          BatchNumber:''
        },
      ],
      tableDataSummary: [
        {
          ProductNo: "",
          ProductName: "",
          UnitType: 0,
          UnitName: "",
          Quantity: null,
          Price: null,
          Amount: null,
          UnitName2: "",
          Price2: null,
          Quantity2: null,
        }
      ],
      delTableData: [],
      viewType: "create",
      isUseProcess: true,
      isUseColor: true,
      keepData: [],
      OrderType: 0,
      detailFields: [],
      showDetail: false,
      Head:[
        { Value: "BatchNumber", Name: "批号", Width: "180" },
        { Value: "WarehouseName", Name: "仓库", Width: "100" },
        { Value: "ColorName", Name: "颜色", Width: "80" },
        { Value: "PropertyName", Name: "属性", Width: "80" },
        { Value: "BatchStartDate", Name: "批次起始日期", Width: "100" },
        { Value: "ExpireDate", Name: "有效期至", Width: "100" },
        { Value: "BaseUnitName", Name: "主单位", Width: "80" }, 
        { Value: "BaseQuantity", Name: "现存量", Width: "80" }
      ],
      batchListTotal:0,
      batchPageParams: {
        pageSize: 7, //分页大小
        pageIndex: 1,
      },
      batchList:[]
    };
  },
  watch: {
    tableData: {
      handler(newVal, oldVal) {
        console.log('items 发生变化');
        console.log('新值:', newVal);
        console.log('旧值:', oldVal);
      },
      deep: true
    }
  },
  created() {
    this.init();
  },
  computed: {
    canPrice() {
      return this.$permission.canPrice("/business/stock/outsourcingpicking");
    },
    canWrite() {
      return this.$permission.canWrite("/business/stock/outsourcingpicking");
    },
    canReview() {
      return this.$permission.canReview("/business/stock/outsourcingpicking");
    },
  },
  mounted() {
    this.viewType = this.$route.params.type;
    if (this.$route.params.type === "create") {
      this.getPreviewNo();
      const user = this.$store.state.user;
      if (user) {
        this.data.EmpId = user.empId;
        this.data.EmpName = user.name;
      }
    } else if (this.$route.params.type === "edit") {
      this.editInit(this.$route.params.data);
    }
  },
  methods: {
    openSetField() {
      this.$refs.fieldDialog.open().then(that => {
        that.getData({ DocType: "委外领料单", Url: "business/stock/outsourcingpicking/edit" });
      })
    },
    setTbField() {
      this.showDetail = false;
      this.docSetting_api.list({ DocType: "委外领料单", IsShow: true }).then(res => {
        if (res.Code == 0) {
          this.detailFields = res.Data.map(x => x.FormKey);
          this.$nextTick(() => {
            this.showDetail = true;
          })
        }
      })
    },
    showField(type) {
      return this.detailFields.indexOf(type) != -1;
    },
    option() { },
    integerQuantity(row, index) {
      if (this.data.MinusEntry) {
        row.Quantity = 0 - row.Quantity
        row.Quantity2 = 0 - row.Quantity2
      } else {
        row.Quantity = Math.abs(row.Quantity)
        row.Quantity2 = Math.abs(row.Quantity2)
      }
    },
    onInsert(e) {
      let { type, index } = e;
      this.interpolate(null, index, type);
    },
    //更改克重
    changeGrammage(data, row, index, type = 0) {
      if (data == "-" || data == "." || data == "") return;
      console.log("row", row)
      this.editT(row);
      if (row.UnitType == 1) {
        if (row.HasGrammage == true) {
          row.Rate = Number((row.Grammage / row.Variable).toFixed(5));
          if (row.IsMain) {
            row.Quantity2 = this.getQuantity(row.Quantity / Number(row.Rate));
            console.log("row.IsMain1", row.IsMain, Number(row.Rate));
            if (type === 0) {
              row.Amount = this.setAmount(row.Price, row.Quantity);
            }
          } else {
            row.Quantity2 = this.getQuantity(row.Quantity * Number(row.Rate));
            console.log(
              "row.IsMain2",
              row.IsMain,
              Number(row.Rate)
            );
          }
        }
      }
    },
    interpolate(row, index, type = "") {
      let o = {
        T: 0,
        DocId: 0,
        DocProductId: 0,
        ProductId: "",
        ProductName: "",
        ProductNo: "",
        ProductSpec: "",
        Quantity: 0,
        InventoryQuantity: 0,
        DiffQuantity: 0,
        Price: 0,
        Amount: 0,
        CheckAmount: 0,
        ProfitLossAmount: 0,
        Quantity2: 0,
        InventoryQuantity2: 0,
        DiffQuantity2: 0,
        Rate: "",
        UnitName: "",
        UnitName2: "",
        UnitId: "",
        UnitId2: "",
        Units: [],
      };
      if (type == "down") {
        index = index + 1;
      }
      this.tableData.splice(index, 0, o);
      let copy = JSON.parse(JSON.stringify(this.tableData));
      this.tableData = [];
      this.$nextTick(() => {

        this.tableData = copy;
      })
      console.log("this.tableData", this.tableData)

    },
    setEmp(data) {
      console.log(data);
      this.data.EmpId = data.EmpId;
      this.data.EmpName = data.EmpName;
    },
    openEmp() {
      this.$refs.empDialog.open().then((that) => {
        that.getData();
      });
    },
    getPreviewNo(dateTime = "") {
      this.code_api.previewNo("委外领料单", dateTime).then((res) => {
        if (res.Code == 0) {
          this.Mode = res.Data.Mode;
          this.data.DocNo = res.Data.PreviewNo;
        } else {
          this.$message.warning("获取委外领料单编号失败");
        }
      });
    },
    async goJump(index) {
      let params = {}
      let ids = [];
      let res = null;
      switch (index) {
        case 1:
          ids = this.tableData.filter(item => {
            return item.SourceType === 26
          }).map(item => {
            return item.SourceDocId;
          })

          if (ids.length === 0) {
            this.$message.error('单据未引用工单，无法进行联查')
          } else {
            params.Ids = ids;
            params.ProductionType = 1;
            this.$router.push({ name: 'workorder', params: params })
          }
          break;
      }
    },
    editInit(data, type = 'edit') {
      this.viewType = "edit";
      this.isSave = true;
      let {
        GetType,
        BusinessType,
        BusinessTypeId,
        BusinessTypeNo,
        DocDate,
        DocId,
        DocNo,
        EmpId,
        EmpName,
        MakeEmpId,
        MakeEmpName,
        Products,
        Remark,
        ReviewEmpId,
        ReviewEmpName,
        ReviewTime,
        Status,
        SiteWarehouseId,
        GeneralWarehouseId,
        SiteWarehouseName,
        GeneralWarehouseName,
        WorkShopId,
        WorkShopName,


        TradeUnitId,
        TradeUnitName,

        SourceDocId,
        SourceNo,
        SourceDtsId,
        SourceType,
      } = data;

      SiteWarehouseId = SiteWarehouseId !== 0 ? SiteWarehouseId : null;
      GeneralWarehouseId = GeneralWarehouseId !== 0 ? GeneralWarehouseId : null;

      this.data = {
        GetType,
        BusinessType,
        BusinessTypeId,
        BusinessTypeNo,
        DocDate,
        DocId,
        DocNo,
        EmpId,
        EmpName,
        MakeEmpId,
        MakeEmpName,
        Remark,
        ReviewEmpId,
        ReviewEmpName,
        ReviewTime,
        SiteWarehouseId,
        GeneralWarehouseId,
        SiteWarehouseName,
        GeneralWarehouseName,
        WorkShopId,
        WorkShopName,

        TradeUnitId,
        TradeUnitName,

        SourceDocId,
        SourceNo,
        SourceDtsId,
        SourceType,
      };

      this.Status = Status;

      Products.forEach((item, i) => {
        item.T = null;
        item.IsBatchNumber = item.BatchNumber ? true : false
        item.SiteWarehouseId = item.SiteWarehouseId !== 0 ? item.SiteWarehouseId : null;
        item.GeneralWarehouseId = item.GeneralWarehouseId !== 0 ? item.GeneralWarehouseId : null;
        item.PropertyId = item.PropertyId !== 0 ? item.PropertyId : null;
        item.ColorId = item.ColorId !== 0 ? item.ColorId : null;
        item.UnitId = item.UnitId !== 0 ? item.UnitId : null;

        item.Rate = item.ChangeRate;

        item.isSource = (item.SourceDocId === 0 || item.SourceDocId == null) ? false : true

        if (item.Units.length === 0) {
          item.UnitType = 0;
          item.UnitId = item.UnitId ?? item.SkUnitId;
          item.UnitName = item.UnitName ?? item.SkUnitName;
          item.UnitId2 = 0;
          // row.SaUnitName = e.SaUnitName;
          item.UnitName2 = "";
          item.Rate = 0;
          item.Quantity2 = 0;
        } else {

          item.UnitType = 1;
          let index = this.getUnitIndex(3, item.Units, item.UnitId);
          let data = this.getUnitValue(item.Units, index);
          let assistIndex = 0;
          let assistData = {};
          item.IsMain = data.IsMain;
          // row.ChangeType1 = data.ChangeType;
          item.Units.forEach((v) => {
            if (v.ChangeType == 1) item.ChangeType = v.ChangeType;
          });

          if (item.UnitId2 == null || item.UnitId2 == 0) {
            if (data.IsMain) {
              assistIndex = this.getUnitIndex(2, item.Units);
              assistData = this.getUnitValue(item.Units, assistIndex);
              item.Rate = assistData.Rate.toFixed(5);
            } else {
              assistIndex = this.getUnitIndex(1, item.Units);
              assistData = this.getUnitValue(item.Units, assistIndex);
              item.Rate = data.Rate.toFixed(5);
            }
            item.UnitId2 = assistData.UnitId;
            item.UnitName2 = assistData.UnitName;
          }

          if (item.Quantity2 == null) {
            this.changeQuantity(item.Quantity, item, i);
          }
        }
      });

      this.tableData = Products;
    },
    init() {
      this.propertyApi
        .list({
          Status: 1,
        })
        .then((res) => {
          if (res.Code === 0) {
            this.propertyList = res.Data;
          }
        });

      this.pdApi
        .list({
          Status: 1,
          PageIndex: this.pageParams.pageIndex,
          pageSize: this.pageParams.pageSize,
        })
        .then((res) => {
          this.DAccount = res.Data;
          this.initDAccount = res.Data;
          this.listTotal = res.Count;
          this.initTotal = res.Count;
        });

      this.warehouseApi.list({ Status: 1, WarehouseType: 1 }).then((res) => {
        if (res.Code === 0) {
          if (this.viewType === 'create') {
            this.data.GeneralWarehouseId = res.Data[0].WarehouseId;
            this.data.GeneralWarehouseName = res.Data[0].WarehouseName;
          }

          this.warehouseList1 = res.Data.map((item) => {
            return {
              key: item.WarehouseId,
              label: item.WarehouseName,
              value: item.WarehouseId,
            };
          });
        }
      });

      this.warehouseApi.list({ Status: 1, WarehouseType: 3 }).then((res) => {
        if (res.Code === 0) {
          if (this.viewType === 'create') {
            this.data.SiteWarehouseId = res.Data[0].WarehouseId;
            this.data.SiteWarehouseName = res.Data[0].WarehouseName;
          }

          this.warehouseList2 = res.Data.map((item) => {
            return {
              key: item.WarehouseId,
              label: item.WarehouseName,
              value: item.WarehouseId,
            };
          });
        }
      });

      this.sourceTypeApi.list({}).then(res => {
        if (res.Code == 0) {
          this.SourceTypeIdArr = res.Data
          let params = "委外领料单"
          let index = this.SourceTypeIdArr.findIndex(item => item.SourceType == params)
          let SourceTypeId = this.SourceTypeIdArr[index].SourceTypeId
          this.data.GetType = SourceTypeId
          this.businessTypeApi.getSourceTypeToBusinessType(SourceTypeId).then(res => {
            if (res.Code == 0) {
              this.businessTypeList = res.Data
              if (this.viewType !== 'edit') {
                this.data.BusinessTypeId = this.businessTypeList[0].BusinessTypeId
                this.data.BusinessType = this.businessTypeList[0].BusinessType
                this.data.MinusEntry = this.businessTypeList[0].MinusEntry
                this.changeNumber(this.data.MinusEntry)
              } else {

                console.log('this.data.BusinessTypeId', this.data.BusinessTypeId)
                let item = this.businessTypeList.filter(item => {
                  return item.BusinessTypeId === this.data.BusinessTypeId
                })[0]

                this.data.MinusEntry = item.MinusEntry;

                this.changeNumber(this.data.MinusEntry)

              }
            }
          })
        }
      })
      this.tradeUnitApi.list({ TradeUnitType: 3, Status: 1 }).then((res) => {
        if (res.Code === 0) {
          this.tradeUnitList = res.Data.map((item) => {
            return {
              key: item.TradeUnitId,
              label: item.FullName,
              value: item.TradeUnitId,
            };
          });
        }
      });
      this.callOptionApi();
      this.setTbField();
    },
    BusinessChange(val) {
      this.data.BusinessTypeId = val.BusinessTypeId
      this.data.MinusEntry = val.MinusEntry
      this.data.BusinessType = val.BusinessType
      this.changeNumber(this.data.MinusEntry)
    },
    changeNumber(status) {
      if (status) {
        this.tableData.forEach(
          (item, index) => {
            item.Quantity = item.Quantity > 0 ? 0 - item.Quantity : item.Quantity
            item.Quantity2 = item.Quantity2 > 0 ? 0 - item.Quantity2 : item.Quantity2
            item.Amount = this.setAmount(item.Quantity,item.Price);

            if (item.T !== 0) {
              item.T = 1
            }
          }
        )
      } else {
        this.tableData.forEach(
          (item, index) => {
            item.Quantity = item.Quantity == null ? item.Quantity : Math.abs(item.Quantity);
            item.Quantity2 = item.Quantity2 == null ? item.Quantity2 : Math.abs(item.Quantity2);
            item.Amount = item.Amount == null ? item.Amount : this.setAmount(item.Quantity,item.Price);

            if (item.T !== 0) {
              item.T = 1
            }
          }
        )
      }
    },
    changeBusinessType(val) {
      let item = this.businessTypeList.filter((item) => {
        return val === item.BusinessTypeId;
      })[0];

      this.data.BusinessTypeId = item.BusinessTypeId;
      this.data.BusinessTypeNo = item.BusinessTypeNo;
      this.data.BusinessType = item.BusinessType;
    },
    changeSiteWarehouse(val, row) {
      this.editT(row)

      let item = this.warehouseList2.filter((item) => {
        return item.value === val;
      })[0];

      row.SiteWarehouseName = item.label;
    },
    changeGeneralWarehouse(val, row) {
      this.editT(row)

      let item = this.warehouseList1.filter((item) => {
        return item.value === val;
      })[0];

      row.GeneralWarehouseName = item.label;
    },
    RateChange(data, row, index) {
      if (data < 0 || data == '') return;
      this.editT(row)
      row.Rate = data;
      row.Rate = Number(row.Rate).toFixed(5)
      // this.changeQuantity(this.tableData[index].Quantity,row,index)   
      if (row.IsMain) {
        // row.Quantity2 = (row.Quantity / Number(data)).toFixed(5);
        row.Quantity2 = this.getQuantity(row.Quantity / Number(data))
      } else {
        // row.Quantity = (row.Quantity2 / Number(data)).toFixed(5);
        row.Quantity = this.getQuantity(row.Quantity2 / Number(data))

      }

      let val = this.setNumber(row.Amount / row.Quantity)
      row.Price = this.getPrice(val);

      val = this.setNumber(row.Amount / row.Quantity2)
      row.Price2 = this.getPrice(val);
    },
    changeDataSiteWarehouse(val) {
      console.log(val, 'val')
      let item = this.warehouseList2.filter((item) => {
        return item.value === val;
      })[0];
      for (let i = 0; i < this.tableData.length; i++) {
        if (this.tableData[i].T !== 0) {
          this.tableData[i].T = 1
        }
        this.tableData[i].SiteWarehouseId = item.value,
          this.tableData[i].SiteWarehouseName = item.label
      }
      this.data.SiteWarehouseName = item.label;
    },
    changeDataGeneralWarehouse(val) {
      this.$confirm('修改普通仓库后将统一修改明细普通仓库，是否继续？').then(_ => {
        let item = this.warehouseList1.filter((item) => {
          return item.value === val;
        })[0];
        for (let i = 0; i < this.tableData.length; i++) {
          if (this.tableData[i].T !== 0) {
            this.tableData[i].T = 1
          }
          this.tableData[i].GeneralWarehouseId = item.value,
          this.tableData[i].GeneralWarehouseName = item.label
        }
        this.data.GeneralWarehouseName = item.label;
      }).catch(_ => {});
    },
    changeColor(val, row) {
      this.editT(row)

      let item = row.Colors.filter((item) => {
        return item.ColorId === val;
      })[0];

      row.ColorName = item.ColorName;
    },
    changeProperty(val, row) {
      this.editT(row)

      let item = this.propertyList.filter((item) => {
        return item.PropertyId === val;
      })[0];

      row.PropertyName = item.PropertyName;
    },
    changeUnit(val, row) {
      if (row.T !== 0) {
        row.T = 1;
      }

    },
    changeQuantity(data, row, index, type = 0) {
      if (data == '-' || data == '.' || data == '') {
        return
      }
      this.editT(row)


      if (this.data.MinusEntry) {
        row.Quantity > 0 ? row.Quantity = 0 - row.Quantity : row.Quantity
        row.Quantity2 > 0 ? row.Quantity2 = 0 - row.Quantity2 : row.Quantity2;
        data = data > 0 ? 0 - data : data;
      } else {
        row.Quantity = Math.abs(row.Quantity)
        row.Quantity2 = Math.abs(row.Quantity2)
        data = Math.abs(data)
      }
      if (row.T == 3) this.tableData[index].T = 1;
      if (row.Units.length > 0) {
        if (row.IsMain) {
          // row.Quantity2= (row.Quantity / Number(row.Rate)).toFixed(5);
          row.Quantity2 = this.getQuantity((row.Quantity / Number(row.Rate)))
          if (type === 0) {
            row.Amount = this.setAmount(row.Price, row.Quantity);
          }

        } else {
          row.Quantity2 = this.getQuantity((data * Number(row.Rate)))
          if (type === 0) {
            row.Amount = this.setAmount(row.Price, row.Quantity);
          }
          // if(row.ChangeType1 == 1 && row.Quantity2 != 0){
          //   row.Rate= Math.abs(Number(row.Quantity2/data)).toFixed(5);
          //   if(type === 0){
          //     let val = this.setNumber(Math.abs(row.Amount / data))
          //     row.Price = this.getPrice(val);
          //   }
          // }else if(row.Quantity2 == 0){
          //   // row.Quantity2 = (data * Number(row.Rate)).toFixed(5);
          //   row.Quantity2 = this.getQuantity((data * Number(row.Rate)))
          //   if(type === 0){
          //     row.Amount = this.setAmount(row.Price, row.Quantity);
          //   }
          // }else if(row.ChangeType1 == 0 ){
          //   // row.Quantity2 = (data * Number(row.Rate)).toFixed(5);
          //   row.Quantity2 = this.getQuantity((data * Number(row.Rate)))
          //   if(type === 0){
          //     row.Amount = this.setAmount(row.Price, row.Quantity);
          //   }
          // }

        }
      } else {
        row.Quantity2 = row.Quantity
        row.Amount = this.setAmount(row.Price, row.Quantity);
      }




    },
    compareSaUnit(data, row, index) {
      if (row.T === 3) row.T = 1;
      this.editT(row);

      let lastIsMain = row.IsMain;
      this.tableData[index].IsMain = data.IsMain
      this.tableData[index].UnitName = data.UnitName
      let findIndex = 0
      if (row.UnitId == row.UnitId2) {
        let num = 0
        num = row.Quantity
        row.Quantity = row.Quantity2
        row.Quantity2 = num

        if (data.IsMain) {
          //当前选择的主单位
          findIndex = this.getUnitIndex(2, this.tableData[index].Units)
          this.changeRightUnitId(index, findIndex)
          // row.ChangeType1 = data.ChangeType;
        } else {
          findIndex = this.getUnitIndex(1, this.tableData[index].Units)
          this.changeRightUnitId(index, findIndex)
          // row.ChangeType1 = data.ChangeType;
        }
      } else {
        if (data.IsMain) {
          findIndex = this.getUnitIndex(2, this.tableData[index].Units)
          this.changeRightUnitId(index, findIndex)
          // row.ChangeType1 = data.ChangeType;
        } else {
          findIndex = this.getUnitIndex(1, this.tableData[index].Units)
          this.changeRightUnitId(index, findIndex, data.Rate)
          // row.ChangeType1 = data.ChangeType;
          if (lastIsMain) {
            row.Quantity2 = row.Quantity;
          }
          // row.Quantity = (row.Quantity2 / Number(data.Rate)).toFixed(5);
          row.Quantity = this.getQuantity(row.Quantity2 / Number(data.Rate))


        }
      }
      this.changeQuantity(this.tableData[index].Quantity, row, index, 1)

      let val = this.setNumber(Math.abs(row.Amount / row.Quantity))
      row.Price = this.getPrice(val);

      val = this.setNumber(Math.abs(row.Amount / row.Quantity2))
      row.Price2 = this.getPrice(val);

    },
    changePrice(val, row) {
      this.editT(row);

      // val = this.setNumber(val)
      // row.Price = this.getPrice(val);
      row.Price = val;
      var amount = this.setAmount(row.Price, row.Quantity);
      row.Amount = this.getAmount(amount);

      if (row.UnitId2 && row.Quantity2 !== 0) {
        row.Price2 = this.getPrice(Number(row.Amount.toString().replace(',','')) / Number(row.Quantity2));
      }
    },
    changePrice2(val, row) {
      this.editT(row);


      // val = this.setNumber(val)
      // row.Price2 = this.getPrice(val);

      row.Price = val;
      var amount = this.setAmount(row.Price2, row.Quantity2);
      row.Amount = this.getAmount(amount);
      if (row.Quantity !== 0) {
        row.Price = this.getPrice(row.Amount / row.Quantity);
      }

    },
    setAmount(p, q) {
      return Number((p * q).toFixed(5));
    },
    changeAmount(val, row) {
      this.editT(row);

      if (this.data.MinusEntry) {
        val = val > 0 ? 0 - val : val;
      } else {
        val = Math.abs(val)
      }
      row.Amount = Number((this.setNumber(val)).toFixed(5));

      if (row.Quantity !== 0) {
        row.Price = this.getPrice(Math.abs(row.Amount / row.Quantity));
      } else {
        this.$message({ type: 'warning', message: '数量不能为0' })
        row.Amount = 0;
        return
      }

      if (row.Units.length > 0) {
        if (row.Quantity2 !== 0) {
          row.Price2 = this.getPrice(Math.abs(row.Amount / row.Quantity2));
        } else {
          this.$message({ type: 'warning', message: '数量2不能为0' })
          row.Amount = 0;
          return
        }
      }


    },
    onSelect(e, row) {
      this.editT(row)

      row.Grammage= e.Grammage,
      row.HasGrammage= e.HasGrammage,
      row.Variable= e.Variable
      row.IsBatchNumber = e.BatchNumber ?? false
      row.BatchNumber = null
      row.BatchStartDate = row.IsBatchNumber ? row.BatchStartDate : null
      row.ColorId = null;
      row.PropertyId = null;

      row.SourceDocId = 0;
      row.SourceNo = "";
      row.SourceDtsId = 0;
      row.SourceType = 0;

      row.Colors = [];
      row.Units = [];
      row.UnitName = "";
      row.ColorName = "";
      row.ProductName = e.ProductName;
      row.ProductNo = e.ProductNo;
      row.ProductId = e.ProductId;
      row.ProductSpec = e.ProductSpec;
      row.Colors = e.Colors;
      row.Units = e.Units;
      row.SiteWarehouseId = this.data.SiteWarehouseId;
      row.SiteWarehouseName = this.data.SiteWarehouseName;
      row.GeneralWarehouseId = this.data.GeneralWarehouseId;
      row.GeneralWarehouseName = this.data.GeneralWarehouseName;
      row.UseColor = e.UseColor;
      row.UseProcess = e.UseProcess;
      row.UnitId = e.SkUnitId;
      row.UnitName = e.SkUnitName;
      row.ChangeType = 0;
      row.UnitType = 0
      // if (this.data.SiteWarehouseId == 0 || this.data.SiteWarehouseId == null) return this.$message.warning("请先选择现场仓库");
      // if (this.data.GeneralWarehouseId == 0 || this.data.GeneralWarehouseId == null) return this.$message.warning("请先选择普通仓库");

      if (e.Units.length === 0) {
        row.UnitId = e.SkUnitId;
        row.UnitName = e.SkUnitName;
      } else {
        console.log(row.UnitId, 'row.UnitId')
        e.Units.forEach(item => {
          if (item.ChangeType == 1) row.ChangeType = item.ChangeType
        })
        if (row.UnitId) {
          row.UnitType = 1
          let index = this.getUnitIndex(3, e.Units, row.UnitId)
          let data = this.getUnitValue(e.Units, index)
          let assistIndex = 0
          let assistData = {}
          row.IsMain = data.IsMain

          if (data.IsMain) {
            assistIndex = this.getUnitIndex(2, e.Units)
            assistData = this.getUnitValue(e.Units, assistIndex)
            row.Rate = (assistData.Rate).toFixed(5);
          } else {
            assistIndex = this.getUnitIndex(1, e.Units)
            assistData = this.getUnitValue(e.Units, assistIndex)
            row.Rate = (data.Rate).toFixed(5);
          }
          row.UnitId2 = assistData.UnitId
          row.UnitName2 = assistData.UnitName
        } else {
          let untiLength = e.Units.length;
          let mainData = [];
          let noMainData = [];
          for (let i = 0; i < untiLength; ++i) {
            if (e.Units[i].IsMain) {
              mainData.push(e.Units[i])
            } else {
              noMainData.push(e.Units[i])
            }
          }
          row.UnitId = mainData[0].UnitId;
          row.UnitName = mainData[0].UnitName;
          row.UnitId2 = noMainData[0].UnitId;
          row.UnitName2 = noMainData[0].UnitName;
          row.Rate = noMainData[0].Rate.toFixed(5);
          row.IsMain = true;
        }

      }


    },
    changeRightUnitId(index, findIndex, Rate = 0) {
      this.tableData[index].UnitId2 = this.tableData[index].Units[findIndex].UnitId
      this.tableData[index].UnitName2 = this.tableData[index].Units[findIndex].UnitName
      // this.tableData[index].ChangeType2=this.tableData[index].Units[findIndex].ChangeType 

      if (Rate > 0) {
        this.tableData[index].Rate = Rate
      }
    },
    editT(row) {


      if (row.T !== 0) {
        row.T = 1;
      }
    },
    changeQuantity2(data, row, index, type = 0) {
      console.log('data', data)

      if (data == '-' || data == '.' || data == '') {
        return
      }
      this.editT(row)
      // if(this.data.MinusEntry){
      //       row.Quantity2=0-row.Quantity2 
      //      }else{
      //       row.Quantity2=Math.abs(row.Quantity2)           
      //      }
      if (this.data.MinusEntry) {
        row.Quantity > 0 ? row.Quantity = 0 - row.Quantity : row.Quantity
        row.Quantity2 > 0 ? row.Quantity2 = 0 - row.Quantity2 : row.Quantity2;
        data = data > 0 ? 0 - data : data;
      } else {
        row.Quantity = Math.abs(row.Quantity)
        row.Quantity2 = Math.abs(row.Quantity2)
        data = Math.abs(data)
      }
      if (row.T === 3) row.T = 1;
      if (row.IsMain == false) {
        if (row.ChangeType == 1 && row.Quantity != 0) {
          row.Rate = Math.abs(Number(data / row.Quantity)).toFixed(5);
          if (type === 0) {
            let val = this.setNumber(Math.abs(row.Amount / data))
            row.Price2 = this.getPrice(val);
          }
        } else {
          console.log("数量1=数量2/换算率")
          // row.Quantity=Number(data/row.Rate).toFixed(5);
          if (row.Quantity === 0) {
            row.Quantity = this.getQuantity(data * row.Rate)
          } else {
            row.Quantity = this.getQuantity(data / row.Rate)
          }
          if (type === 0) {
            row.Amount = this.setAmount(row.Price2, row.Quantity2);
          }
        }
      } else {
        if (row.ChangeType == 1 && row.Quantity != 0) {
          row.Rate = Math.abs(Number(row.Quantity / data)).toFixed(5);
          if (type === 0) {
            let val = this.setNumber(Math.abs(row.Amount / data))
            row.Price2 = this.getPrice(val);
          }

        } else {
          console.log("数量1=数量2*换算率")
          // row.Quantity=Number(data*row.Rate).toFixed(5);
          row.Quantity = this.getQuantity(data * row.Rate)
          if (type === 0) {
            row.Amount = this.setAmount(row.Price2, row.Quantity2);
          }
        }
      }

    },
    getUnitValue(arr, findIndex) {
      let data = {}
      data.UnitId = arr[findIndex].UnitId
      data.UnitName = arr[findIndex].UnitName
      data.IsMain = arr[findIndex].IsMain
      data.ChangeType = arr[findIndex].ChangeType
      data.Rate = arr[findIndex].Rate
      return data
    },
    //获取计量单位主辅单位的索引 
    getUnitIndex(type, arr, id = '') {
      let index = 0
      if (type == 1) {
        //获取主单位索引
        index = arr.findIndex(el => el.IsMain == true)
      } else if (type == 2) {
        //获取数组第一个不是主单位的索引
        index = arr.findIndex(el => el.IsMain == false)
      } else {
        //获取当前传入id的索引
        index = arr.findIndex(el => id == el.UnitId)
      }
      return index
    },
    changeLeftUnitId(index, findIndex, Rate = 0) {
      this.tableData[index].UnitId = this.tableData[index].Units[findIndex].UnitId
      this.tableData[index].SaUnitName = this.tableData[index].Units[findIndex].UnitName
      // this.tableData[index].ChangeType1=this.tableData[index].Units[findIndex].ChangeType 

      if (Rate > 0) {
        this.tableData[index].Rate = Rate
      }
    },
    compareUnitId(data, row, index) {
      if (row.T === 3) row.T = 1;

      this.editT(row);

      let lastIsMain = row.IsMain;
      if (data.IsMain) {
        this.tableData[index].IsMain = false
      } else {
        this.tableData[index].IsMain = true
      }
      this.tableData[index].UnitName2 = data.UnitName
      let findIndex = 0
      if (row.UnitId == row.UnitId2) {
        let num = 0
        num = row.Quantity
        row.Quantity = row.Quantity2
        row.Quantity2 = num

        if (this.tableData[index].IsMain == false) {
          //当前选择的主单位
          findIndex = this.getUnitIndex(2, this.tableData[index].Units)
          this.changeLeftUnitId(index, findIndex)
          // row.ChangeType2 = data.ChangeType;
        } else {
          findIndex = this.getUnitIndex(1, this.tableData[index].Units)
          this.changeLeftUnitId(index, findIndex)
          //  row.ChangeType2 = data.ChangeType;
        }


      } else {
        if (this.tableData[index].IsMain == false) {
          //当前选择的主单位
          findIndex = this.getUnitIndex(2, this.tableData[index].Units)
          this.changeLeftUnitId(index, findIndex)
          //  row.ChangeType2 = data.ChangeType;
        } else {
          findIndex = this.getUnitIndex(1, this.tableData[index].Units)
          this.changeLeftUnitId(index, findIndex, data.Rate)
          // row.ChangeType2 = data.ChangeType;
          if (!lastIsMain) {
            row.Quantity = row.Quantity2
          }
          // row.Quantity2 = (row.Quantity / Number(data.Rate)).toFixed(5);
          row.Quantity2 = this.getQuantity(row.Quantity / Number(data.Rate));

        }
      }
      this.changeQuantity2(this.tableData[index].Quantity2, row, index, 1)

      let val = this.setNumber(Math.abs(row.Amount / row.Quantity))
      row.Price = this.getPrice(val);

      val = this.setNumber(Math.abs(row.Amount / row.Quantity2))
      row.Price2 = this.getPrice(val);

    },
    resetFun() {
      this.pageParams.pageIndex = 1;
      this.DAccount = this.initDAccount;
      this.listTotal = this.initTotal;
    },
    currentPage({ val, text1 }, row) {
      this.pageParams.pageIndex = val;
      this.pdApi.list({ pageIndex: val, pageSize: 7, Status: 1, ProductName: text1 }).then((res) => {
        if (res.Code == 0) {
          this.DAccount = res.Data;
          this.listTotal = res.Count;
        }
      });
    },
    inputText(text, row) {

      row.ProductName = text;
      this.pdApi
        .list({ pageIndex: 1, pageSize: 7, ProductName: text, Status: 1, })
        .then((res) => {
          if (res.Code == 0) {
            this.DAccount = res.Data;

            this.listTotal = res.Count;
          }
        });
    },
    async openPage() {
      const res = await this.sourceTypeApi.info("委外领料单")
      this.OrderType = res.SourceTypeId
      this.$refs.editDialog.open();
    },
    del(row, index) {
      this.$confirm("确认删除这条数据吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then((res) => {
        if (row.T !== 0) {
          row.T = 2;
          row.SiteWarehouseId = row.SiteWarehouseId ? row.SiteWarehouseId : 0;
          row.GeneralWarehouseId = row.GeneralWarehouseId ? row.GeneralWarehouseId : 0;
          row.PropertyId = row.PropertyId ? row.PropertyId : 0;
          row.ColorId = row.ColorId ? row.ColorId : 0;
          row.UnitId = row.UnitId ? row.UnitId : 0;
          this.delTableData.push(row);
        }

        this.tableData.splice(index, 1);
        if (this.tableData.length === 0) {
          this.newLine();
        }
      });
    },
    tableRowClassName({ row, rowIndex }) {
      row.index = rowIndex;
    },
    newLine() {
      let o = {
        T: 0,
        DocId: 0,
        DocProductId: 0,
        WorkDocNo: "",
        SiteWarehouseId: null,
        GeneralWarehouseId: null,
        SiteWarehouseName: "",
        GeneralWarehouseName: "",
        ProductId: null,
        ProductNo: "",
        ProductName: "",
        ProductSpec: "",
        PropertyId: null,
        PropertyName: "",
        ColorId: null,
        ColorName: "",
        Colors: [],
        Units: [],
        UnitId: null,
        UnitName: "",
        Quantity: null,
        Price: null,
        Amount: null,

        UnitId2: null,
        UnitName2: "",
        Price2: null,
        Quantity2: null,
        Rate: null,

        SourceDocId: 0,
        SourceNo: "",
        SourceDtsId: 0,
        SourceType: 0,
        Remark: "",
      };

      this.tableData.push(o);
    },
    add(row, column) {
      if (column.label === "操作" || this.Status === 2) {
        return;
      }
      if (row.index === this.tableData.length - 1) {
        this.newLine();
      }
    },
    async saved({ subList, TradeUnitId }) {
      this.data.TradeUnitId = TradeUnitId;
      console.log('this.data.TradeUnitId', this.data.TradeUnitId)
      let arr = [];
      const res = await this.sourceTypeApi.info("生产工单材料")
      console.log("res", res)
      let SourceType = res.SourceTypeId
      subList.forEach((item) => {
        let o = {
          T: 0,
          DocId: 0,
          DocProductId: 0,
          WorkDocNo: "",
          SiteWarehouseId: null,
          GeneralWarehouseId: null,
          SiteWarehouseName: "",
          GeneralWarehouseName: "",
          ProductId: item.ProductId,
          ProductNo: item.ProductNo,
          ProductName: item.ProductName,
          ProductSpec: item.ProductSpec,
          PropertyId: item.PropertyId || 0,
          PropertyName: item.PropertyName || "",
          UseColor: item.UseColor,
          UseProcess: item.UseProcess,
          ColorId: item.ColorId || 0,
          ColorName: item.ColorName || "",
          Colors: item.Colors || [],
          Units: item.Units || [],
          UnitId: item.UnitId,
          UnitName: item.UnitName,
          Quantity: item.Quantity,
          Price: 0,
          Price2: 0,
          Amount: 0,
          SourceDocId: item.WorkDocId,
          SourceNo: item.WorkDocNo,
          SourceDtsId: item.WorkDocMaterialId,
          SourceType: SourceType,
          SiteWarehouseId: this.data.SiteWarehouseId,
          SiteWarehouseName: this.data.SiteWarehouseName,
          GeneralWarehouseId: item.DefaultWarehouse,
          GeneralWarehouseName: "",
          Grammage: item.Grammage,
          HasGrammage: item.HasGrammage,
          Variable: item.Variable,
          SkUnitId: item.SkUnitId,
          SkUnitName: item.SkUnitName
        };
        arr.push(o);
        if(this.tableData.length == 0 || !this.tableData[0].SourceNo) {
          this.data.GeneralWarehouseId = arr[0].GeneralWarehouseId;
          this.data.GeneralWarehouseName = arr[0].GeneralWarehouseName;
        }
      });

      arr.forEach((item, i) => {
        item.isSource = (item.SourceDocId === 0 || item.SourceDocId == null) ? false : true
        item.UnitType = 0
        item.ChangeType = 0;
        // item.Units.forEach(v=>{
        //   if(v.ChangeType==1)item.ChangeType=v.ChangeType
        // })
        if (item.Units.length === 0) {

        } else {
          item.UnitType = 1
          if (item.UnitId != item.SkUnitId) {
              if (item.Units.filter(x => x.IsMain && x.UnitId == item.UnitId).length > 0) {
                  item.Quantity = item.Quantity / item.Units.find(x => !x.IsMain && x.UnitId == item.SkUnitId).Rate;
              } else {
                  item.Quantity = item.Quantity * item.Units.find(x => !x.IsMain && x.UnitId == item.UnitId).Rate;
              }
              item.UnitId = item.SkUnitId;
              item.UnitName = item.SkUnitName;
          }
          let index = this.getUnitIndex(3, item.Units, item.UnitId)
          let data = this.getUnitValue(item.Units, index)
          let assistIndex = 0
          let assistData = {}
          item.IsMain = data.IsMain
          // row.ChangeType1 = data.ChangeType;
          item.Units.forEach(item2 => {
            if (item2.ChangeType == 1) item.ChangeType = item2.ChangeType
          })
          if (data.IsMain) {
            assistIndex = this.getUnitIndex(2, item.Units)
            assistData = this.getUnitValue(item.Units, assistIndex)
            item.Rate = (assistData.Rate).toFixed(5);
          } else {
            assistIndex = this.getUnitIndex(1, item.Units)
            assistData = this.getUnitValue(item.Units, assistIndex)
            item.Rate = (data.Rate).toFixed(5);
          }
          item.UnitId2 = assistData.UnitId
          item.UnitName2 = assistData.UnitName
          // row.ChangeType2 = assistData.ChangeType;
        }

        this.changeQuantity(arr[i].Quantity, item, i, 1)
      })

      this.tableData.unshift(...arr);

    },
    getProducts(data) {
      let Products = [];
      data.forEach((item) => {
        let {
          T,
          DocId,
          DocProductId,
          WorkDocNo,
          SiteWarehouseId,
          GeneralWarehouseId,
          SiteWarehouseName,
          GeneralWarehouseName,
          ProductId,
          ProductNo,
          ProductName,
          ProductSpec,
          PropertyId,
          PropertyName,
          ColorId,
          ColorName,
          Colors,
          Units,
          UnitId,
          UnitName,
          Quantity,
          Price,
          Amount,

          UnitId2,
          UnitName2,
          Quantity2,
          Price2,
          Rate,

          SourceDocId,
          SourceNo,
          SourceDtsId,
          SourceType,
          ChangeType,

          Remark,
          UseColor,
          UseProcess,
          BatchNumber
        } = item;

        SiteWarehouseId = SiteWarehouseId ? SiteWarehouseId : 0;
        GeneralWarehouseId = GeneralWarehouseId ? GeneralWarehouseId : 0;
        PropertyId = PropertyId ? PropertyId : 0;
        ColorId = ColorId ? ColorId : 0;
        UnitId = UnitId ? UnitId : 0;
        Price = Price ?? 0;
        Amount = Amount ?? 0;


        let o = {
          T,
          DocId,
          DocProductId,
          WorkDocNo,
          SiteWarehouseId,
          GeneralWarehouseId,
          SiteWarehouseName,
          GeneralWarehouseName,
          ProductId,
          ProductNo,
          ProductName,
          ProductSpec,
          PropertyId,
          PropertyName,
          ColorId,
          ColorName,
          Colors,
          Units,
          UnitId,
          UnitName,
          Quantity,
          Price,
          Amount,
          UnitId2,
          UnitName2,
          Quantity2,
          Price2,
          ChangeRate: Rate,

          SourceDocId,
          SourceNo,
          SourceDtsId,
          SourceType,
          ChangeType,
          Remark,
          UseColor,
          UseProcess,
          BatchNumber
        };

        Products.push(o);
      });

      return Products;
    },
    save(type = 0) {

      //验证表单是否填写
      let yanzheng = ['DocDate', 'DocNo', 'SiteWarehouseId', 'GeneralWarehouseId', 'BusinessTypeId', 'TradeUnitId',
        , 'EmpId',]
      for (let key in this.data) {

        if (yanzheng.indexOf(key) !== -1 && (!this.data[key])) {
          this.$message({ type: 'warning', message: '表单未填写完整' })
          return;
        }
      }
      let Products = this.getProducts(this.tableData);
      this.keepData = Products;
      // console.log(this.data,'this.data')
      if (Products.length > 0 && Products[0].ProductName != '') {

      } else {
        this.$message({ type: 'warning', message: '明细列表不能为空' })
        return
      }
      Products = Products.concat(this.delTableData);
      Products = Products.filter((item) => {
        return item.T != null && item.ProductId !== 0 && item.ProductId != null;
      });

      var btId = 0;
      var obj = this.businessTypeList.find(x => x.BusinessType == "委外退料");
      if(obj) btId = obj.BusinessTypeId;

      let ProductsLength = Products.length;
      for (let i = 0; i < ProductsLength; ++i) {
        if(this.data.BusinessTypeId == btId && btId) {
          if (Products[i].Amount > 0) {
            this.$message({ type: "warning", message: "金额不能大于0" });
            return;
          }
        } else {
          if (Products[i].Amount < 0) {
            this.$message({ type: "warning", message: "金额不能小于0" });
            return;
          }
        }
        if (Products[i].UseColor && Products[i].ColorId === 0) {
          this.$message.error(`存货${Products[i].ProductName}未填写颜色`)
          return;
        }
        // if (Products[i].UseProcess && Products[i].PropertyId === 0) {
        //   this.$message.error(`存货${Products[i].ProductName}未填写属性`)
        //   return;
        // }
        if (!Products[i].Quantity) {
          this.$message({ type: 'warning', message: '请填写存货数量，存货数量不能为0' })
          return
        }
      }


      this.data.WorkShopId = this.data.WorkShopId ?? 0;
      let o = {
        Products,
        ...this.data,
      };

      this.api.save(o).then((res) => {
        if (res.Code === 0) {
          if (this.viewType === "create") {
            this.data.DocId = res.Data;
          }
          if (type !== 1) {
            this.$message.success(res.Msg);
          }
          this.isSave = true;

          this.api.info(this.data.DocId).then((res) => {
            if (res.Code === 0) {
              this.$route.params.data = res.Data;
              if (type === 1) {
                this.reView1()
              } else {
                this.editInit(res.Data, 'keep');
              }

            }
          });
        } else {
          this.$message({ type: "warning", message: res.Msg });
        }
      });
    },
    newAdd() {
      if (!this.isSave) {
        this.$message({ type: "warning", message: "请先进行保存再操作" });
        return;
      } else {
        Object.assign(this.$data, this.$options.data.call(this));
        this.getPreviewNo();
        this.$route.params.type = "create";
        this.viewType = "create";
        this.init();
        this.isSave = false;
      }
    },
    reView1() {
      let id = this.data.DocId;
      this.api.examine(id).then((res) => {
        if (res.Code === 0) {
          this.$message({ type: "success", message: res.Msg });
          this.api.info(this.data.DocId).then((res) => {
            if (res.Code === 0) {
              this.$route.params.data = res.Data;
              this.editInit(res.Data);
            }
          });
        } else {
          this.$message({ type: "warning", message: res.Msg });
        }
      });
    },
    reView() {
      this.save(1)
    },
    cancelReView() {
      let id = this.data.DocId;
      this.api.cancelExamine(id).then((res) => {
        if (res.Code === 0) {
          this.$message({ type: "success", message: res.Msg });
          this.api.info(this.data.DocId).then((res) => {
            if (res.Code === 0) {
              this.$route.params.data = res.Data;
              this.editInit(res.Data);
            }
          });
        } else {
          this.$message({ type: "warning", message: res.Msg });
        }
      });
    },
    handleDelete() {
      let Id = this.data.DocId;
      this.$confirm("确定删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then((res) => {
        this.api.delete({ Id }).then((res) => {
          if (res.Code === 0) {
            this.$message({ type: "success", message: res.Msg });
            this.newAdd();
            // this.$emit('deleted')
          } else {
            this.$message({ type: "warning", message: res.Msg });
          }
        });
      });
    },
    /** 打开批号弹框 */
    onOpenBatch(e, row, index) {
      this.batchPageParams.pageIndex = 1;
      let o = {
        IsInOut:1,
        WarehouseId:row.GeneralWarehouseId,
        ProductId: row.ProductId,
        PropertyId:row.PropertyId,
        ColorId:row.colorId,
        pageIndex: 1,
        pageSize: 7,
      } 
      var params = this.$commonJs.obj.removeNullKey(o);
      this.pdApi.productBatchNumberList(params).then((res) => {
        if (res.Code == 0) {
          this.batchList = res.Data.map(item=>{
            return {
              ...item,
              BatchStartDate: this.$commonJs.toDateString(item.BatchStartDate),
              ExpireDate: this.$commonJs.toDateString(item.ExpireDate)
            }
          });
          this.batchListTotal = res.Count;
        }else {
          this.$message.error(res.Msg);
        }
      });
    },
    /** 选择批号 */
    onSelBatch(e, row, index){
      if (row.T !== 0) {
        row.T = 1
      }
      if(e.BatchNumber !== row.BatchNumber){
        row.BatchNumber = e.BatchNumber
      }
    },
    /** 输入批号 */
    inputTextBatch(text, row) {
      if (row.T !== 0) {
        row.T = 1
      }
      row.BatchNumber = text;
      //IsInOut 入库-0 出库-1
      let o = {
        IsInOut:1,
        WarehouseId:row.GeneralWarehouseId,
        ProductId: row.ProductId,
        PropertyId:row.PropertyId,
        ColorId:row.colorId,
        BatchNumber:row.BatchNumber,
        pageIndex: 1,
        pageSize: 7,
      } 
      var params = this.$commonJs.obj.removeNullKey(o);
      this.pdApi.productBatchNumberList(params).then((res) => {
        if (res.Code == 0) {
          this.batchList = res.Data.map(item=>{
            return {
              ...item,
              BatchStartDate: this.$commonJs.toDateString(item.BatchStartDate),
              ExpireDate: this.$commonJs.toDateString(item.ExpireDate)
            }
          });
          this.batchListTotal = res.Count;
        }else {
          this.$message.error(res.Msg);
        }
      });
    },
    /** 批号下一页 */
    currentPageBatch({ val, text1 }, row) {
      this.batchPageParams.pageIndex = val;
      let o = {
        IsInOut:1,
        WarehouseId:row.GeneralWarehouseId,
        ProductId: row.ProductId,
        PropertyId:row.PropertyId,
        ColorId:row.colorId,
        ProductName:row.ProductName,
        pageIndex: val,
        pageSize: 7,
      } 
      var params = this.$commonJs.obj.removeNullKey(o);
      this.pdApi.productBatchNumberList(params).then((res) => {
        if (res.Code == 0) {
          this.batchList = res.Data.map(item=>{
            return {
              ...item,
              BatchStartDate: this.$commonJs.toDateString(item.BatchStartDate),
              ExpireDate: this.$commonJs.toDateString(item.ExpireDate)
            }
          });
          this.batchListTotal = res.Count;
        }else {
          this.$message.error(res.Msg);
        }
      });
    },
    handleClick(tab, event) {
      if(this.activeName == "2"){
        this.tableDataSummary = this.summarizeTableData()
        console.log(this.tableDataSummary);
        
      }
    },
    summarizeTableData() {
      const summary = {};
      // 遍历所有产品，进行汇总
      console.log('this.tableData',this.tableData)
      this.tableData.forEach(product => {
        if(product.ProductNo){
          if (!summary[product.ProductNo]) {
            // 如果是第一次遇到该产品，则初始化
            summary[product.ProductNo] = {
              ProductNo: product.ProductNo,
              ProductName: product.ProductName,
              UnitType: product.UnitType,
              UnitName: product.UnitName,
              UnitName2: product.UnitName2,
              Quantity: product.Quantity,
              Quantity2: product.UnitType == 1 ? product.Quantity2 : 0,
              Amount: product.Price * product.Quantity,
              Price: 0,
              Price2: 0,
              count: 1
            };
          } else {
            // 否则，累加数量和总价，并增加计数
            if(product.UnitType == 1 && summary[product.ProductNo].UnitName != product.UnitName){
              summary[product.ProductNo].Quantity += product.Quantity2;
              summary[product.ProductNo].Quantity2 += product.Quantity;
            }else{
              summary[product.ProductNo].Quantity += product.Quantity;
              if(product.UnitType == 1)
                summary[product.ProductNo].Quantity2 += product.Quantity2;
            }
            summary[product.ProductNo].Amount += product.Price * product.Quantity;
            summary[product.ProductNo].count++;
          }
        }
      });
    
      // 将汇总结果转换为数组，并计算平均单价
      return Object.values(summary).map(sum => ({
        ProductNo: sum.ProductNo,
        ProductName: sum.ProductName,
        UnitType: sum.UnitType,
        UnitName: sum.UnitName,
        UnitName2: sum.UnitName2,
        Quantity: sum.Quantity,
        Quantity2: sum.Quantity2,
        Amount: sum.Amount,
        Price: (sum.Amount / sum.Quantity).toFixed(5), // 计算平均单价
        Price2: sum.UnitType == 1 ? (sum.Amount / sum.Quantity2).toFixed(5) : 0 // 计算平均单价
      }));
    },
    // 非分页 千位符+保留后两位
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      const fieldNames = columns.map(col => col.property);
      fieldNames.forEach((field, index) => {
        if (field && ['Quantity','Quantity2','Amount'].includes(field)) {
          const values = data.map(item => Number(item[field]));
          console.log('values',values)
          if (!values.every(value => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + value;
              } else {
                return prev;
              }
            }, 0);
          } else {
            sums[index] = '/';
          }
        } else {
          sums[index] = '';
        }
      });
      sums[0] = '合计';
      return sums;
    },
  },
};
</script>

<style lang="scss" scoped>
.dropdown-item {
  padding: 6px;
}

.mtx10 {
  padding: 10px;
}

.flex {
  display: flex;
  .text {
    width: 60px;
  }
}
.space-between {
  justify-content: space-between;
}

.center {
  display: flex;
  justify-content: center;
  align-items: center;
}

.flex1 {
  flex: 1;
}

.mrx18 {
  margin-right: 18px;
}
.span {
  display: inline-block;
  width: 180px;
}

.w180 {
  width: 180px;
}
</style>
